module.exports = {
	"ha": "iha",
	"id": 5.7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by HSDA, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.2972972972973,
						"dataLabels": {
							"enabled": true,
							"format": "36"
						}
					},
					{
						"y": 75.67567567567568,
						"dataLabels": {
							"enabled": true,
							"format": "28"
						}
					},
					{
						"y": 70.27027027027027,
						"dataLabels": {
							"enabled": true,
							"format": "26"
						}
					},
					{
						"y": 59.45945945945946,
						"dataLabels": {
							"enabled": true,
							"format": "22"
						}
					},
					{
						"y": 43.24324324324324,
						"dataLabels": {
							"enabled": true,
							"format": "16"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.36065573770492,
						"dataLabels": {
							"enabled": true,
							"format": "60"
						}
					},
					{
						"y": 90.1639344262295,
						"dataLabels": {
							"enabled": true,
							"format": "55"
						}
					},
					{
						"y": 86.88524590163934,
						"dataLabels": {
							"enabled": true,
							"format": "53"
						}
					},
					{
						"y": 83.60655737704919,
						"dataLabels": {
							"enabled": true,
							"format": "51"
						}
					},
					{
						"y": 49.18032786885246,
						"dataLabels": {
							"enabled": true,
							"format": "30"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.89473684210527,
						"dataLabels": {
							"enabled": true,
							"format": "372"
						}
					},
					{
						"y": 90.78947368421053,
						"dataLabels": {
							"enabled": true,
							"format": "345"
						}
					},
					{
						"y": 89.47368421052632,
						"dataLabels": {
							"enabled": true,
							"format": "340"
						}
					},
					{
						"y": 82.63157894736842,
						"dataLabels": {
							"enabled": true,
							"format": "314"
						}
					},
					{
						"y": 60.526315789473685,
						"dataLabels": {
							"enabled": true,
							"format": "230"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.19047619047619,
						"dataLabels": {
							"enabled": true,
							"format": "202"
						}
					},
					{
						"y": 88.09523809523809,
						"dataLabels": {
							"enabled": true,
							"format": "185"
						}
					},
					{
						"y": 87.61904761904762,
						"dataLabels": {
							"enabled": true,
							"format": "184"
						}
					},
					{
						"y": 79.04761904761905,
						"dataLabels": {
							"enabled": true,
							"format": "166"
						}
					},
					{
						"y": 54.761904761904766,
						"dataLabels": {
							"enabled": true,
							"format": "115"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.7027027027026973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.6393442622950838,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.6363636363636376,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.7735849056603765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.17647058823529,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.1052631578947323,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.258064516129037,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.449275362318836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.647058823529407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.751592356687905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.809523809523807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.415841584158413,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.540540540540535,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.782608695652172,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.722891566265066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "East Kootenay<br>n=37"
			},
			{
				"x": 9,
				"text": "Kootenay Boundary<br>n=61"
			},
			{
				"x": 15,
				"text": "Okanagan<br>n=380"
			},
			{
				"x": 21,
				"text": "Thompson Cariboo Shuswap<br>n=210"
			}
		],
		"dataTable": {
			"East Kootenay": [
				37,
				36,
				28,
				26,
				22,
				16
			],
			"Kootenay Boundary": [
				61,
				60,
				55,
				53,
				51,
				30
			],
			"Okanagan": [
				380,
				372,
				345,
				340,
				314,
				230
			],
			"Thompson Cariboo Shuswap": [
				210,
				202,
				185,
				184,
				166,
				115
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_7.json
// module id = 240
// module chunks = 0